import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Container = styled.div`
  position: relative;
  margin: 28px 0;
  &:before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 40px;
    height: 40px;
    margin-top: -10px;
    margin-left: -10px;
    border-radius: 50%;
    border-top: 4px solid ${Color.primary};
    border-right: 4px solid transparent;
    animation: spinner 0.6s linear infinite;
  }
  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }
`
